import axios from 'axios'
import { Message } from 'element-ui' // 引入 Element 提示组件
import { Session } from '@/utils/storage';

// 创建 axios 实例
const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API, // 从环境变量取接口前缀
    timeout: 30000 // 请求超时时间
});

// 请求拦截器：添加 token 等请求头
service.interceptors.request.use(
    config => {
        let token = Session.get('token')
        if (token) {
            config.headers['token'] = token
        }
        return config;
    },
    error => {
        console.log('请求错误：', error);
        return Promise.reject(error);
    }
);

// 响应拦截器：统一处理响应/错误
service.interceptors.response.use(
    (response) => {
        const res = response.data;
        // 假设接口返回 code=200 为成功
        if (response.status !== 200) {
            Message({
                message: res.msg || '请求失败',
                type: 'error',
                duration: 3 * 1000
            });
            return Promise.reject(new Error(res.msg || '请求失败'));
        } else {
			return Promise.resolve(res)
        }
    },
    (error) => {
        // 对响应错误做点什么
        if (error.message && error.message.indexOf('timeout') != -1) {
            Message.error('网络超时');
        } else if (error.message === 'Network Error') {
            Message.error('网络连接错误');
        } else if (error.response && error.response.data && error.response.data.msg) {
            Message.error(error.response.data.msg);
        } else {
            Message.error('请求失败');
        }
        return Promise.reject(error);
    }
);

export default service;